export default __webpack_public_path__ + "static/media/billing_bg.873ab3a6.png";